// extracted by mini-css-extract-plugin
module.exports = {"favourite":"SearchResults_favourite__1O9xM"};